import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex bg-grey-lighten-1" }
const _hoisted_2 = { class: "d-flex align-start switches-wrapper" }


export default /*@__PURE__*/_defineComponent({
  __name: 'DIL_Switches',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const model = _useModel<Array<Boolean>>(__props, "modelValue");


return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_col, {
          cols: "1",
          style: {"padding-right":"0px"}
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "d-flex flex-column justify-space-between align-center fill-height" }, [
              _createElementVNode("span", { class: "status-text" }, "ON"),
              _createElementVNode("span", { class: "status-text" }, "OFF")
            ], -1)
          ])),
          _: 1,
          __: [0]
        }),
        _createVNode(_component_v_col, {
          cols: "11",
          style: {"padding-left":"0px"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(model.value, (bit, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createVNode(_component_v_switch, {
                    "model-value": bit,
                    class: "rotated-switch",
                    color: "yellow",
                    "hide-details": "",
                    readonly: ""
                  }, null, 8, ["model-value"]),
                  _createVNode(_component_v_row, { class: "switch-label" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(index + 1), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})